/*jslint node: true, browser: true*/

"use strict";

var ko = require("pli/knockout");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var selectionForm = require("../common-selectionform");
var viewModelInit = require("../document/viewModelInitExtensions");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// RelatedWell class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function RelatedWell(factories) {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("RelatedWell.ctor", factories); }

    this.guid = ko.observable(null);
    this.id = this.wellNumber = pliObservable(null, dataCache.getObservable("well"), "required", "picklist");

    // non-serialized properties
    this.extras = function RelatedWellExtras() { return; };
    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
    this.extras.license = ko.observable(null);
    this.extras.operator = ko.observable(null);
    this.extras.released = ko.observable(null);
    this.extras.spud = ko.observable(null);
    this.extras.wellStatus = pliObservable(null, dataCache.getObservable("wellStatus"), "picklist");
    this.extras.producingStatus = ko.observable(null);
    this.extras._subscriptionUpdateInfo = null;
    if (ko.isObservable(this.id.item)) {
        this.extras._subscriptionUpdateInfo = this.id.item.subscribe(this._updateInfo, this);
        this._updateInfo(this.id.item()); // force initial update
    }
}


//---------------------------------------
RelatedWell.prototype.initGridArray = function initRelatedWellGridArray(gridArray) {
    /// <summary>
    /// Add extra methods to the specified
    /// related wells grid array (that has just
    /// been created).
    /// </summary>
    gridArray.linkItems = gridArray.factory.factories.secureAction(RelatedWell.prototype._linkItems, gridArray);
    gridArray.copyItems = gridArray.factory.factories.secureAction(RelatedWell.prototype._copyItems, gridArray);
    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
    gridArray.openNew = null;

    gridArray.openTarget = RelatedWell.prototype._openTarget.bind(gridArray);
};


//-------------------------------------------
RelatedWell.prototype.itemComparer = null; // disable client-side sorting


//-------------------------------------------
RelatedWell.prototype.loadViewModel = function loadRelatedWell(record) {
    if (window.console && window.console.group) { window.console.log("RelatedWell.loadViewModel", record); }

    this.guid(record.guid || null);
    this.id.load((record && record.id) || null);
};


//-------------------------------------------
RelatedWell.prototype._linkItems = function linkWells() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and add related wells to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores related wells.
    /// </remarks>
    selectionForm.open({
        multiSelect: true,
        searchApi: "Geo-Well-SearchUwi",
        text: {
            acceptButton: "Link",
            iconClass: "sprite-link-16",
            examples: [
                "<strong>06-22-057-15-W4</strong>",
                "<strong>121/06-22-057-15-W4/00</strong>"
            ],
            title: "Link Wells"
        },
        onAcceptedContext: this,
        onAccepted: function (newWellRows) {
            selectionForm.utils.pushRowItems({
                targetArray: this,
                records: newWellRows,
                rowMap: { id: 0 },
                getIdentity: function (relatedWell) { return relatedWell.id(); }
            });
        }
    });
};


//-------------------------------------------
RelatedWell.prototype._copyItems = function copyWells() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and add related wells to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores related wells.
    /// </remarks>
    selectionForm.open({
        multiSelect: true,
        searchApi: "Geo-Document-SearchRelatedWells",
        text: {
            acceptButton: "Copy",
            iconClass: "sprite-link-16",
            examples: [
                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"],
            title: "Copy Wells"
        },
        onAcceptedContext: this,
        onAccepted: function (newWellRows) {
            selectionForm.utils.pushRowItems({
                targetArray: this,
                records: newWellRows,
                rowMap: { id: 4 }
            });
        }
    });
};


//-------------------------------------------
RelatedWell.prototype._openTarget = function openRelatedWell() {
    var targetId = this.current().id();
    if (targetId) {
        entityRegistry.well.open.edit({ uniqueName: targetId });
    }
};


//-------------------------------------------
RelatedWell.prototype._updateInfo = function updateRelatedWellInfo(wellRow) {
    /// <remarks>
    /// Assumes "this" points to a related well.
    /// </remarks>
    this.extras.license(wellRow ? wellRow[5] : null);
    this.extras.operator(wellRow ? wellRow[2] : null);
    this.extras.released(wellRow && wellRow[7] ? wellRow[7] : null);
    this.extras.spud(wellRow && wellRow[6] ? wellRow[6] : null);
    this.extras.wellStatus.load(wellRow ? wellRow[4] : null);
    var producingStatus = this.extras.wellStatus && this.extras.wellStatus.item() && this.extras.wellStatus.item()[2];
    this.extras.producingStatus(producingStatus ? (producingStatus === "P" ? "Producing" : "Non-producing") : null);
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = viewModelInit.standardFactoryCreatorFor(
    RelatedWell,
    "relatedWells"
);



//////////////////
// WEBPACK FOOTER
// ./app/document-relatedwell/relatedWellViewModel.js
// module id = 556
// module chunks = 49